export const ColumnGapClasses = {
  GAP_NONE: ['wf-px-0'],
  GAP_SM: ['wf-px-2'],
  GAP_LG: ['wf-px-4'],
  GAP_XL: ['wf-px-8'],
}